module.exports = __webpack_public_path__ + "static/media/Lue.bf27fe15.PNG";